module.exports = __webpack_public_path__ + "img/logo30.78246e09.jpg";